import { Component, EventEmitter, Input, OnInit, Output, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { ComboBoxComponent } from '@progress/kendo-angular-dropdowns';
import { SiteLisitng } from '~/models/administration/site';
import { UserSummary } from '~/models/administration/user';
import { MultiSiteService } from '~/services/modules/common/multi-site.service';
import { SecurityService } from '~/services/security.service';
import { SitesEnum } from '~/shared/enums/sites.enum';

@Component({
    selector: 'all-sites-dropdown',
    templateUrl: './all-sites-dropdown.component.html',
    styleUrls: ['./all-sites-dropdown.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AllSitesDropdownComponent implements OnInit {

  //#region multi site report Variables
  _sites: any[] = [];
  _sitesFiltered: any[] = [];
  @Input() _siteSelected: any;
  @Input() _customSelectedSiteId: any;
  @Input() isEdit: boolean = false;
  @ViewChild('kendo_combo_SiteCode') kendoComboGroupName: ComboBoxComponent;

  @Output() sitesChangedEvent: EventEmitter<any> = new EventEmitter();
  @Output() sitesLoadedEvent: EventEmitter<any> = new EventEmitter();
  isLoggedInAllSites: boolean = false;
  sitesIsLoaded: boolean = false;
  _currentUser: UserSummary;
  //#endregion
  constructor(private _multiSitesService: MultiSiteService, private _securityService: SecurityService) {
    this._currentUser = this._securityService.currentUser;
    //#region droddown Subscription
    //  this._multiSitesService.updateAllSitesDropdownValue.subscribe(siteId => {
    //   if(siteId)
    //   this._siteSelected = this._sites.find(x => x.id == siteId);
    //   else
    //   this._siteSelected = this._sites.find(x => x.code == "All Sites");
    //   this.siteSelected = this._siteSelected;
    //   });

    //#endregion
  }

  ngOnInit(): void {
    if (!this._currentUser.isEnterprise) {
      this._loadSites();
    }
  }

  initDropDown() {
    const loggedInAccountSites = localStorage.getItem('loggedInAccountSites') ?? "";

    if (loggedInAccountSites != "") {
      var site = JSON.parse(loggedInAccountSites)[0];

      if (!site.siteId || site.siteId === SitesEnum.AllSites) {
        this.isLoggedInAllSites = true;
      }
      else {
        this.isLoggedInAllSites = false;
      }

      if (!this._customSelectedSiteId) {
        this._siteSelected = this._sites.find(x => x.code == "All Sites");
      }
      else {
        this._siteSelected = this._sites.find(x => x.id == this._customSelectedSiteId);
      }
    }
  }

  //#region multi site Functions
  _loadSites() {
    this._multiSitesService.getAllSites().subscribe((data: any) => {
      this._sites = data || [];
      this._sitesFiltered = this._sites;
      this.sitesIsLoaded = true;
      this.initDropDown();
    });
  }

  _handleSitesFilter(value: any) {
    this._sitesFiltered = this._sites.filter((s: any) => s.code.toLowerCase().indexOf(value.toLowerCase()) !== -1);
  }

  _handleSitesChange(event: SiteLisitng) {
    this.sitesChangedEvent.emit(event);
  }
  //#endregion
}
